module.exports = __webpack_public_path__ + "static/media/circle-green.c0508fbd.svg";